/**
 * This directive sets up the Firsthand "hinted input" functionality without requiring page load
 * <div ... hinted-input type="" label="" default="" ng-change=""...></div>
 */
export function hintedInput() {
    return {
        restrict: 'A',
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/angular-utilities/directives/hintedInput.html',
        scope: {
            label: '@label',
            type: '@type',
            value: '=ngModel',
        },
        require: 'ngModel',
        controller: [
            '$scope', $scope => {
                $scope.uniqueString = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
            },
        ],
        link: (scope, element, attrs, controller) => {
            const _elem = $(element);
            _elem.addClass('input');

            scope.blur = scope.focus = () => {
                if (scope.type === 'date' || scope.type === 'time' || scope.value) {
                    if (!_elem.hasClass('active')) {
                        _elem.addClass('active');
                    }
                } else {
                    _elem.removeClass('active');
                }
            };

            scope.valueChange = () => {
                scope.focus();
                controller.$setViewValue(scope.value);
            };

            controller.$render = () => {
                scope.value = controller.$modelValue;
            };

            scope.focus();

            scope.$on('refreshInput', scope.focus);
        },
    };
}
